export default __webpack_public_path__ + "static/media/Ecoe_logo_h.632dddd2.svg";